import type { ConstValues } from '@openx/types/helpers';

export const GAP_SIZE = 32;
export const IFRAME_IMPRESSION_CONTAINER_SIZE = 25;
export const DEFAULT_PREVIEW_WIDTH = 320;
export const DEFAULT_PREVIEW_HEIGHT = 250;
export const CONTAINER_SIZE = 500;

export const IconSize = {
  S: 18,
  M: 46,
  L: 80,
} as const;
export type IconSize = ConstValues<typeof IconSize>;

export const TextVariant = {
  Horizontal: 'horizontal',
  Vertical: 'vertical',
  None: 'none',
} as const;
export type TextVariant = ConstValues<typeof TextVariant>;
